import type { BuiltinFieldPreference, ContactField, ContactFieldValue, FieldCatalog, FieldSection, FieldType, FieldChoice, FieldValue } from "@shared/contactFields";
import { apiRequest } from "./queryClient";
export type FieldInput = { label: string; description: string; section: FieldSection; type: FieldType; choices: FieldChoice[] };
const json = async <T>(method: string, path: string, data?: unknown): Promise<T> => {
  try {
    const response = await apiRequest(method, path, data);
    return await response.json();
  } catch (cause) {
    const match = cause instanceof Error ? /^(\d{3}):\s*([\s\S]*)$/.exec(cause.message) : null;
    if (!match) throw cause;
    let message = match[2];
    try { message = JSON.parse(message).error ?? message; } catch { /* Plain HTTP error. */ }
    throw Object.assign(new Error(message), { status: Number(match[1]) });
  }
};
export const contactFieldsApi = {
  catalog: () => json<FieldCatalog>("GET", "/api/contact-fields"),
  updateBuiltin: (key: string, input: { revision: number; label?: string; hidden?: boolean }) =>
    json<BuiltinFieldPreference>("PATCH", `/api/contact-fields/builtins/${encodeURIComponent(key)}`, input),
  create: (input: FieldInput) => json<ContactField>("POST", "/api/contact-fields", input),
  reorder: (section: FieldSection, fields: { id: string; revision: number }[]) =>
    json<{ saved: boolean }>("POST", "/api/contact-fields/reorder", { section, fields }),
  update: (id: string, input: Partial<FieldInput> & { revision: number; archived?: boolean; sortOrder?: number }) =>
    json<ContactField>("PATCH", `/api/contact-fields/${id}`, input),
  values: (leadId: number) => json<ContactFieldValue[]>("GET", `/api/leads/${leadId}/custom-fields`),
  saveValue: (leadId: number, fieldId: string, input: { value: FieldValue; revision: number; definitionRevision: number }) =>
    json<ContactFieldValue>("PUT", `/api/leads/${leadId}/custom-fields/${fieldId}`, input),
  mergePreview: (ids: number[]) => json<{ fields: ContactField[]; values: Record<string, ContactFieldValue[]> }>("POST", "/api/contact-fields/merge-preview", { ids }),
};
